import axios from 'axios'

export default class Pagination {
  constructor(holder) {
    this.holder = holder
    if (!this.holder) return

    this.activeClass = 'active'
    this.view = this.holder.getAttribute('data-view')
    this.authorId = this.holder.getAttribute('data-author')
    this.postsPerPage = this.holder.getAttribute('data-posts_per_page')
    this.blockHolder = this.holder.querySelector('.js-pagination-holder')
    this.page = 1
    this.url = ajax.url
    this.matchMedia = '(min-width: 960px)'
    this.device = ''

    this.loadPage()
    this.paginationEvents()
  }

  loadPage() {
    this.checkDevice()

    axios({
      method: 'post',
      url: `${this.url}&action=pagination&view=${this.view}&author=${this.authorId}&post_count=${this.postsPerPage}&paged=${this.page}&show=${this.device}`
    }).then(response => {

      this.clearHolder()
      this.renderNewArticles(response.data)
      this.paginationEvents()
    })
  }

  clearHolder() {
    this.blockHolder.innerHTML = ''
  }

  renderNewArticles(data) {
    this.blockHolder.insertAdjacentHTML('beforeend', data)
  }

  paginationEvents() {
    let pages = [...document.querySelectorAll('.page-numbers')]

    pages.forEach(page => {
      page.addEventListener('click', e => {
        e.preventDefault()

        this.holder.scrollIntoView({ behavior: 'smooth' })

        let currentPage

        pages.forEach(el => {
          if (el.classList.contains('current')) {
            currentPage = +el.textContent
          }
          el.classList.remove('current')
        })

        if (!page.classList.contains('next') && !page.classList.contains('prev')) {
          this.page = +page.textContent
          page.classList.add('current')
        }

        if (page.classList.contains('next')) {
          this.page = currentPage + 1
        }

        if (page.classList.contains('prev')) {
          this.page = currentPage - 1
        }

        this.loadPage()
      })
    })
  }

  checkDevice() {
    if (this.authorId) {
      this.matchMedia = '(min-width: 1440px)'
    }

    if (!window.matchMedia(this.matchMedia).matches) {
      this.device = 'mobile'
    }
  }
}